// @ts-nocheck

import { useState } from 'react';

const fallbackCopyTextToClipboard = (text: string) => {
  const textArea = document.createElement('textarea');
  textArea.value = text;

  textArea.style.visibility = 'none';
  textArea.style.zIndex = '-9999';
  textArea.style.position = 'fixed';
  textArea.style.top = '0';
  textArea.style.left = '0';
  textArea.style.width = '0';
  textArea.style.height = '0';
  textArea.style.opacity = '0';
  textArea.style.pointerEvents = 'none';

  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

  document.execCommand('copy');

  document.body.removeChild(textArea);
};

const useCopyToClipboard = () => {
  const [copiedText, setCopiedText] = useState();

  const copy = async (text: string) => {
    if (!navigator?.clipboard) {
      console.warn('Clipboard not supported');
      return false;
    }

    try {
      await navigator.clipboard.writeText(text);
      setCopiedText(text);
      return true;
    } catch (error) {
      try {
        fallbackCopyTextToClipboard(text);
        setCopiedText(text);
        return true;
      } catch (errorFallback) {
        console.error('Failed to copy to clipboard', errorFallback);
        setCopiedText(null);
        return false;
      }
    }
  };

  return { value: copiedText, onCopy: copy };
};

export default useCopyToClipboard;
